<ion-icon [name]="(num <= rating) ? 'star' : 'star-outline'"
          [size]="size"
          *ngFor="let num of [1,2,3,4,5]"
          (click)="rate(num)"
          [ngStyle]="{ 'color': (num <= rating) ? '#fddb31' : '#000000'}">
</ion-icon>
